module.exports = __webpack_public_path__ + "img/2.faee0734.png";